
<template>
<div class="nb-modal-scrollable">
    <div id="mymodal" class="container nb-modal-scrollable-container">
        <div class="nb-modal-scrollable-body">
                <div>
                    <bar-manut 
                        single-entity="Lançamento Caixa e Bancos" 
                        :crud="this.crud" 
                        :moreActions="moreActions"
                        @action="handleAction"
                        @closeform="closeForm" 
                        @save="handleSave">
                    </bar-manut>
                    <div class="row">
                        <div class="col-md-9">
                            <!-- MENSAGENS DE VALIDACAO -->
                            <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
                            <!-- FIM MENSAGENS DE VALIDACAO -->
                            <div class="row">
                                <form-field ref="conta" v-model="fin.codcta" type="select2" col="6" :metadata="metadata.fin.codcta" :disabled="isView"
                                    parent="mymodal" name="codcta" :v-errors="errors" v-validate="metadata.fin.codcta.validator"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.data" type="date" col="3" :metadata="metadata.fin.data" :disabled="isView"
                                    name="data" :v-errors="errors" v-validate="{ required: true }"></form-field>
                                <form-field v-model="fin.doc" type="text" col="3" :metadata="metadata.fin.doc" :disabled="isView" 
                                    name="doc" :v-errors="errors" v-validate="metadata.fin.doc.validator"></form-field>
                                <form-field v-model="tipo" type="select" col="3" label="Tipo"
                                    :select-options="tipoOptions" name="tipo" :v-errors="errors" v-validate="{ required: true }"></form-field>                                
                                <form-field v-model="fin.vlr" type="value" col="3" :metadata="metadata.fin.vlr"  :disabled="isView"
                                    name="vlr" :v-errors="errors" v-validate="metadata.fin.vlr.validator"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.descricao" type="text" col="6" :metadata="metadata.fin.descricao" :disabled="isView"
                                    name="descricao" :v-errors="errors" v-validate="metadata.fin.descricao.validator"></form-field>
                            </div>
                            <!-- <div class="row">
                                <form-field v-model="fin.texto" type="memo" col="6" :metadata="metadata.fin.texto" :disabled="isView"
                                    name="texto" :v-errors="errors" v-validate="metadata.fin.texto.validator"></form-field>
                            </div> -->
                            <div class="row">
                                <form-field v-if="tipo == 'E'" v-model="fin.codnatfin" type="select2" col="6" :metadata="metadataCodnatfin" :disabled="isView"
                                    parent="mymodal" name="codnatfin" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                                <form-field v-else v-model="fin.codnatfin" type="select2" col="6" :metadata="metadataCodnatfin" :disabled="isView"
                                    parent="mymodal" name="codnatfin" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.codpart" type="select2" col="6" :metadata="metadata.fin.codpart" :disabled="isView"
                                    parent="mymodal" name="codpart" :v-errors="errors" v-validate="{ required: false }"></form-field>
                            </div>
                            <label-title title="Confirmar Cancelamento" v-if="cancelarMovimento == 'S'"></label-title>
                            <div class="row mb-3" v-if="cancelarMovimento == 'S'">
                                <div class="col-12">
                                    <span class="data-list">Esta operação não poderá ser desfeita.</span>
                                </div>
                                <div class="col-md-12 col-12">
                                    <v-button label="Confirmar Cancelamento" title="" :danger="true" @click="handleCancelar"></v-button>
                                    <v-button label="Desistir" @click="handleDesistir"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDS, apiORDSpost, urlODS } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            fin: {...this.$store.getters.getEntities.fin},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            tipoOptions: [{ id: 'E', text: "Entrada" }, { id: 'S', text: "Saída" }],
            tipo: 'E',
            cancelarMovimento: 'N',
        }
    },

    computed: {
        metadataCodnatfin: function () {
            let meta = {...this.metadata.fin.codnatfin }
            if (this.tipo == 'R' || this.tipo == 'E')
              meta.select2.entity = 'natfin/receitas'
            else
              meta.select2.entity = 'natfin/despesas'
            return meta
        },
        moreActions: function () {
            if (this.crud == SysVars.crudI)
              return null
              
            let actions = []
            actions.push({ action: 1, label: 'Cancelar Movimento' })
            return actions
        },

        editing: function () {
            return this.crud == SysVars.crudU
        },

        isView: function () {
            return (this.crud == SysVars.crudView)
        },

        _tituloNF: function () {
            if (!this.fin.codnf && !this.fin.codpedv) {
                return false
            } else {
                return true
            }
        },

    },

    methods: {
        handleAction (act) {
            if (act == 1)
                this.cancelarMovimento = 'S'
        },

        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            if (this.crud == SysVars.crudI) {
                this.fin.aberto = 'N'
                this.fin.baixado = 'S'
                this.fin.data = this.$getDate()
                return
            }
            await this.$store.dispatch('loadFin', { id: this.index } )
            if (this.$store.getters.getFin) {
                this.fin = {...this.$store.getters.getFin}
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async handleDesistir () {
            this.cancelarMovimento = 'N'
        },
        
        async handleCancelar () {
            var modulo = 'fin/movimento/' + this.fin.codfin
            let postData = { cancela: true, codfin: this.codfin }
            const data = await apiORDSpost(this.$store, modulo, postData, 'put')
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            this.fin.baixado = 'S'
            this.fin.aberto = 'N'
            this.fin.tipofin = this.tipo

            var modulo = 'fin/movimento/'
            var sendData = {}
            sendData = { fin: this.fin }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                modulo = modulo + this.fin.codfin
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    components: {

    },

    watch: {



    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          this.$refs.conta.focus()
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        this.loadData()  
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/financeiro-movimento-form.vue